document.addEventListener("DOMContentLoaded", function () {
// document.addEventListener('click', function (e) {
//   e.preventDefault();
//   const element = e.target; 
// //console.log(element);  
// })




document.querySelectorAll("li").forEach(li => {
  if ([...li.classList].some(cls => /^cori-hide--.+?-hide$/.test(cls))) {
    li.style.display = "none";
  }
});

  
document.addEventListener("input", function (event) {
    if (event.target.matches(".quantity__input")) {
        let productId = event.target.getAttribute("data-product");
        let newValue = event.target.value;

        // Update all inputs with the same product ID
        document.querySelectorAll(`.quantity__input[data-product='${productId}']`).forEach(input => {
            input.value = newValue;
        });
    }
});


  
  var password = document.getElementById("RegisterForm-password"),
      confirm_password = document.getElementById("confirm-password");

  if (password && confirm_password) {
    function validatePassword() {
      if (password.value !== confirm_password.value) {
        confirm_password.setCustomValidity("Passwords Don't Match");
      } else {
        confirm_password.setCustomValidity('');
      }
    }

    password.addEventListener("change", validatePassword);
    confirm_password.addEventListener("keyup", validatePassword);

    // Additional check on form submit
    var form = document.getElementById("register-form");
    if (form) {
      form.addEventListener("submit", function (e) {
        validatePassword();
        if (!form.checkValidity()) {
          e.preventDefault(); // Prevent form submission if validation fails
        }
      });
    }
  }




  // Open popup on button click
  document.querySelectorAll(".open-popup-btn").forEach(function (button) {
    button.addEventListener("click", function () {
      var target = this.getAttribute("data-target");
      document.querySelector(target).style.display = "flex";
    });
  });

  // Close popup when clicking the close button
  document.querySelectorAll(".close-modal").forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function () {
      this.closest(".custom-modal").style.display = "none";
    });
  });

  // Close popup when clicking outside the modal content
  window.addEventListener("click", function (event) {
    document.querySelectorAll(".custom-modal").forEach(function (modal) {
      if (event.target === modal) {
        modal.style.display = "none";
      }
    });
  });


    // Select all open sidebar buttons
    document.querySelectorAll(".open-sidebar").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent default link behavior
            let sidebarId = this.getAttribute("data-sidebar");
            let sidebar = document.getElementById(sidebarId);
            if (sidebar) {
                sidebar.classList.add("active");
              document.body.classList.add("sidebar_open");
            }
        });
    });

    // Select all close sidebar buttons
    document.querySelectorAll(".halo-sidebar-close").forEach(button => {
        button.addEventListener("click", function () {
            let sidebarId = this.getAttribute("data-sidebar-close");
            let sidebar = document.getElementById(sidebarId);
            if (sidebar) {
                sidebar.classList.remove("active");
              document.body.classList.remove("sidebar_open");
            }
        });
    });

    // Close sidebar when clicking outside
    document.addEventListener("click", function (event) {
        document.querySelectorAll(".halo-sidebar").forEach(sidebar => {
            if (!sidebar.contains(event.target) && !event.target.classList.contains("open-sidebar")) {
                sidebar.classList.remove("active");
              document.body.classList.remove("sidebar_open");
            }
        });
    });





    const variantSelect = document.querySelector(".product-form form input[name='id']");
    const variantSections = document.querySelectorAll(".variant-metafield-section");

    function updateVariantMetafield() {
        if (!variantSelect) return;
        const selectedVariantId = variantSelect.value;

        variantSections.forEach(section => {
            let hasVisibleContent = false;

            // Hide all metafield contents inside each section
            section.querySelectorAll(".variant-content").forEach(content => {
                content.style.display = "none";
            });

            // Show the selected variant's metafield content
            const activeContent = section.querySelector(`.variant-content[data-variant-id='${selectedVariantId}']`);
            if (activeContent && activeContent.innerText.trim() !== "") {
                activeContent.style.display = "inline-block";
                hasVisibleContent = true;
            }

            // Hide or show the section based on content
            section.style.display = hasVisibleContent ? "inline-block" : "none";
        });
    }

    // Initial update on page load
    updateVariantMetafield();

    document.addEventListener("change", function (event) {
        if (event.target.matches(".product-form form input[name='id']")) {
            updateVariantMetafield();
        }
    });

     // const coriguardDiv = document.querySelector(".corigaurd");
     // const variantSection = coriguardDiv.querySelector(".variant-metafield-section");
   const coriguardDiv = document.querySelector(".coriguard");
if (coriguardDiv) {
    const variantSection = coriguardDiv.querySelector(".variant-metafield-section");
    // Now you can safely use variantSection
} 
  

    function updateVisibility() {
        if (variantSection.style.display === "none") {
            coriguardDiv.classList.add("hide");
        } else {
            coriguardDiv.classList.remove("hide");
        }
    }

    // Observe changes in the style attribute of the variant section inside coriguard
    if(coriguardDiv && variantSection)
    {
    const observer = new MutationObserver(updateVisibility);
    observer.observe(variantSection, { attributes: true, attributeFilter: ["style"] });

    // Initial check to set visibility
    updateVisibility();
    }

  

let clickedInside = false;

$(document).on("mousedown", function (e) {
  clickedInside = $(e.target).closest('.swatch_inner_area').length > 0;
});

$(document).on("click", function () {
  if (!clickedInside) {
    $('.product-form__label').removeClass('active');
    $('body').removeClass('material_open');
  }
});


$(document).on("click", ".close-tooltip", function () {
  $('.product-form__label').removeClass('active');
  $('body').removeClass('material_open');
});
















  

    const material_tab = document.querySelectorAll(".material-tab"); 
    const mtabs = document.querySelectorAll(".meta-tab"); // Fix: Use tab buttons
    const buttons = document.querySelectorAll(".meta-tab-btn");
    const swatches = document.querySelectorAll(".metaobjects");


 material_tab.forEach(mtab => {
    mtab.addEventListener("click", function () {         
        material_tab.forEach(t => t.classList.remove("active"));
        this.classList.add("active");         

        const filter = this.getAttribute("data-material_filter");

        $('#view-mode-material').html(filter + ' View'); 
        $('.material_name').html(filter); 

        swatches.forEach(swatch => {
            const matchesFilter = swatch.getAttribute("data-material_type").includes(filter);
            swatch.classList.toggle("hide_by_material", !matchesFilter);
        });

        checkAndRunFunctions();
      setTimeout(function () {
       $('.meta-tab.all').click();
        }, 1000); 
      
      
    });
});


    mtabs.forEach(mtab => {
        mtab.addEventListener("click", function () {
         
            mtabs.forEach(t => t.classList.remove("active"));
            this.classList.add("active");

         
            const filter = this.getAttribute("data-filter");
            swatches.forEach(swatch => {
              swatch.classList.remove("show");
              swatch.classList.remove("hide");
                if (swatch.getAttribute("data-category").includes(filter)) {
                  swatch.classList.add("show");
                } else {
                  swatch.classList.add("hide");
                }
            });
      checkAndRunFunctions();
          
        });
    });

    swatches.forEach(swatch => {
        swatch.addEventListener("click", function () {
            swatches.forEach(s => s.classList.remove("active"));
            this.classList.add("active");
        });
    });

    buttons.forEach(button => {
        button.addEventListener("click", function () {
            buttons.forEach(b => b.classList.remove("active"));
            this.classList.add("active");         
        });
    });




function checkAndRunFunctions() {
$(".material-tab").each(function () {
    var data_material = $(this).attr("data-material_filter");
    if ($(".metaobjects.available[data-material_type='" + data_material + "']").length === 0) {
      $(this).addClass("hide");
    } else {
      $(this).removeClass("hide");
    }
  });

 $(".meta-tab:not(.all)").each(function () {
    var data_metatab = $(this).attr("data-filter");
    if ($(".metaobjects.available:not(.hide_by_material)[data-category*='" + data_metatab + "']").length === 0) {
      $(this).addClass("hide");
    } else {
      $(this).removeClass("hide");
    }
  }); 
  
    if ($("#view-mode-material").hasClass("active")) {
        materialview();
    } else if ($("#view-mode-delivery-time").hasClass("active")) {
        leadtimeview();
    }

}

function sortLeadtime() {
        
        let fieldset = $(".swatch_inner_area");

        if (fieldset.length === 0) return; // Exit if not found

        let pairs = [];

        // Find all input-label pairs
        fieldset.find("input.product-form__radio").each(function () {
            let label = $(this).next("label.metaobjects[data-leadtime]"); // Get the corresponding label
            if (label.length) {
                let leadtime = label.attr("data-leadtime") || "";
                let num = parseInt(leadtime.match(/\d+/)?.[0] || 0, 10); // Extract numeric value

                pairs.push({ leadtimeNum: num, input: $(this), label: label });
            }
        });

        // Sort the pairs by leadtime number (ascending order)
        pairs.sort((a, b) => a.leadtimeNum - b.leadtimeNum);

        // Append sorted pairs back to the fieldset
        pairs.forEach(pair => {
            pair.input.appendTo(fieldset);
            pair.label.appendTo(fieldset);
        });
    }

   function check_first_viable() {
     let previousLeadtime = null;

        // Loop through each visible label
        $("label.metaobjects[data-leadtime]:visible").each(function () {
            let currentLeadtime = $(this).attr("data-leadtime");

            // If it's a new leadtime group, add a class to highlight it
            if (currentLeadtime !== previousLeadtime) {
                $(this).addClass("first-in-group");
                previousLeadtime = currentLeadtime; // Update previous leadtime
            } else {
                $(this).removeClass("first-in-group");
            }
        });
    }

  function addLeadtimeHeadings() {
       $(".material-heading").remove();
    setTimeout(function () {
        let previousLeadtime = null;
        $("label.metaobjects[data-leadtime]:visible").each(function () {
            let currentLeadtime = $(this).attr("data-leadtime");

            // If it's a new leadtime group, add a heading before the input
            if (currentLeadtime !== previousLeadtime) {
                let heading = $("<div class='material-heading'></div>").text("Delivery Time: " + currentLeadtime);
                // Insert the heading before the corresponding input
                $(this).prev("input.product-form__radio").before(heading);
                
                $(this).addClass("first-in-group"); // Add class to first label of the group
                previousLeadtime = currentLeadtime; // Update previous leadtime
            }
        });
      }, 1000); 
    }

function leadtimeview() {
    $('.swatch_inner_area .loader').removeClass('loaded');
    setTimeout(sortLeadtime, 1000);
    setTimeout(check_first_viable, 1500);
    setTimeout(addLeadtimeHeadings, 2000);
    setTimeout(function () {
        $('.swatch_inner_area .loader').addClass('loaded');
    }, 3000);    
}






function sortmaterial() {
    
    let fieldset = $(".swatch_inner_area");

    if (fieldset.length === 0) return; // Exit if not found

    let pairs = [];

    // Find all input-label pairs
    fieldset.find("input.product-form__radio").each(function () {
        let label = $(this).next("label.metaobjects[data-material]"); // Get the corresponding label
        if (label.length) {
            let material = label.attr("data-material") || "";

            pairs.push({ material, input: $(this), label: label });
        }
    });

    // Sort pairs alphabetically by material name (case-insensitive)
    pairs.sort((a, b) => a.material.localeCompare(b.material, undefined, { sensitivity: 'base' }));

    // Append sorted pairs back to the fieldset
    pairs.forEach(pair => {
        pair.input.appendTo(fieldset);
        pair.label.appendTo(fieldset);
    });
}


   function check_first_material_viable() {
     let previousLeadtime = null;

        // Loop through each visible label
        $("label.metaobjects[data-material]:visible").each(function () {
            let currentLeadtime = $(this).attr("data-material");

            // If it's a new leadtime group, add a class to highlight it
            if (currentLeadtime !== previousLeadtime) {
                $(this).addClass("first-in-group");
                previousLeadtime = currentLeadtime; // Update previous leadtime
            } else {
                $(this).removeClass("first-in-group");
            }
        });
    }

  function addmaterialHeadings() {
    $(".material-heading").remove();
    setTimeout(function () {
        let previousmaterial = null;
        // Loop through each visible label
        $("label.metaobjects[data-material]:visible").each(function () {
            let currentmaterial = $(this).attr("data-material");

            // If it's a new leadtime group, add a heading before the input
            if (currentmaterial !== previousmaterial) {
                let materialheading = $("<div class='material-heading'></div>").text(currentmaterial);
                
                // Insert the heading before the corresponding input
                $(this).prev("input.product-form__radio").before(materialheading);
                
                $(this).addClass("first-in-group"); // Add class to first label of the group
                previousmaterial = currentmaterial; // Update previous leadtime
            }
        });
      }, 1000);
    }

function materialview() {
    $('.swatch_inner_area .loader').removeClass('loaded');
    setTimeout(sortmaterial, 1000);
    setTimeout(check_first_material_viable, 1500);
    setTimeout(addmaterialHeadings, 2000);
    setTimeout(function () {
        $('.swatch_inner_area .loader').addClass('loaded');
    }, 3000);    
}

$(document).on("change", ".product-form__input.before_swatch_variants .product-form__radio", function () {  
     checkAndRunFunctions();
   setTimeout(function() {
    $('.material-tab:visible').first().click();
    $('.meta-tab.all').click();
}, 1200);
});
   

  
$(document).on("click", "#view-mode-material", function () {
 materialview();
});

  $(document).on("click", "#view-mode-delivery-time", function () {
 leadtimeview();
});
  
setTimeout(function() {    
    //checkAndRunFunctions();
var current_variant = $('.current_variant').attr('data-material_type');
var materialTab = $('.material-tab[data-material_filter="'+current_variant+'"]');

if (materialTab.length) {
    materialTab.click();
} else {
  $('.meta-tab.all').click();
    //checkAndRunFunctions();
}

//$('.material-tab[data-material_filter="'+current_variant+'"]').click();
 
var data_material_name = $('.swatch_inner_area input:checked').attr("data-material-name");
if (data_material_name) {
    $(".color_legend .form__label span").html(data_material_name);}
}, 2500);

function handleVariantSelection(element) {
  var $el = $(element);

  // Support for <select> <option> where 'name' might not exist
  var m_name = $el.attr('name') || $el.closest('select').attr('name');

  if (m_name === 'Material') {
    $('body').addClass('material_open');
  } else {
    $('body').removeClass('material_open');
  }

  var variant_id = $el.attr("data-variant-id");
  $(".addtowishlistbtn").attr("data-varientid", variant_id);

  var variant_url = $el.attr("data-variant-url");
  $(".addtowishlistbtn").attr("data-producturl", variant_url);

  var data_title = $el.attr("data-title");
  $("#wishlistPopup .caption").html(data_title);

  var data_coriguard = $el.attr("data-coriguard");
  $("#coriguard-value").val(data_coriguard);

  var data_material_name = $el.attr("data-material-name");
  if (data_material_name) {
    $(".color_legend .form__label span").html(data_material_name);
  }

  // var selectedVariantId = $el.attr("data-variant-id");
  // var cylindoCode = $el.attr("data-cylindo-code");
  // var cylindoFeatures = $el.attr("data-cylindo-features");

  // const viewer = document.querySelector("cylindo-viewer");
  // if (viewer) {
  //   viewer.setAttribute("code", cylindoCode);
  // }

  // const cylindoIntegration = document.querySelector("cylindo-shopify-integration");
  // if (cylindoIntegration) {
  //   cylindoIntegration.setAttribute("default-variant-id", selectedVariantId);
  //   // cylindoIntegration.setAttribute("features-by-variant-id", cylindoFeatures);
  // }
}


$(document).on("change", ".product-form__input .product-form__radio", function () {
  handleVariantSelection(this);
});

$(document).on("change", "variant-sticky-selects select", function () {
  // var selectedOption = $(this).find("option:selected");
  var selectedOption = $('.product-form__input .product-form__radio:checked');
  //console.log(selectedOption);
   handleVariantSelection(selectedOption);
});
 


 $(document).on("change", "[data-quickshop] .single-option", function () {
   var data_variant_id = $(this).attr("data-variant-id");
   var data_variant_url = $(this).attr("data-variant-url");
   $(this).parents('.card').find(".addtowishlistbtn").attr("data-varientid", data_variant_id);
   $(this).parents('.card').find(".addtowishlistbtn").attr("data-producturl", data_variant_url);
   
   //console.log("data_value:", data_value);
});
   
// document.addEventListener('click', function (e) {
//  // console.log("Clicked on:", e.target);
// });

document.querySelectorAll("[data-toggle]").forEach(item => {
        item.addEventListener("click", function () {
            let toggleValue = this.getAttribute("data-toggle"); // Get the data-toggle value
            document.body.setAttribute("modal-open", toggleValue); // Add class to <body>
          $('.popup:not([id="'+toggleValue+'"])').removeClass('active');
        });
    });



document.querySelectorAll(".productView-thumbnail-link").forEach(function (button) {
    button.addEventListener("click", function () {
        var targetIndex = parseInt(this.closest('.productView-thumbnail').getAttribute("data-slick-index")) + 1;

        // Find the corresponding image with data-index
        var targetImage = document.querySelector('.productView-image[data-index="' + targetIndex + '"]');

        if (targetImage) {
            // Calculate the scroll position with an offset
            var offset = 50; // Adjust this value to control the gap from the top
            var targetPosition = targetImage.getBoundingClientRect().top + window.scrollY - offset;

            // Smooth scroll to the target position with an offset
            window.scrollTo({ top: targetPosition, behavior: "smooth" });

            document.querySelectorAll('.productView-img-container').forEach(container => {
                container.classList.remove("active");
            });

            var imgContainer = targetImage.querySelector('.productView-img-container');
            if (imgContainer) {
                imgContainer.classList.add("active");
            }
        }
    });
});


    document.querySelectorAll(".toggle-password").forEach(toggle => {
        let passwordField = toggle.previousElementSibling;

        toggle.addEventListener("click", function () {
            if (passwordField.type === "password") {
                passwordField.type = "text";         
                this.classList.add('visi'); 
            } else {
                passwordField.type = "password";
                this.classList.remove('visi'); 
            }
        });
    });

function getLeftOffset() {
  if (window.innerWidth > 767) {
  const element = document.querySelector('.halo-productView-left');

  if (!element) return;
    const offsetRight = element.getBoundingClientRect().right;
    const rightInset = window.innerWidth - offsetRight;

    document.querySelectorAll('.swatch_tooltip').forEach(tooltip => {
      tooltip.style.right = `${rightInset}px`;
    });
  }

}

// Initial call
getLeftOffset();

// Recalculate on resize
window.addEventListener('resize', getLeftOffset);



function move_to_sidebar() {
  const sidebarelement = document.querySelector('.page-sidebar-left .sidebar');

  if (!sidebarelement) return;
    document.querySelectorAll('.side_barcontent').forEach(side_barcontent => {
    sidebarelement.appendChild(side_barcontent);
    });


}   
move_to_sidebar();

window.toggleSwatches = function(id) {
    const container = document.getElementById(id);
    const extraSwatches = container.querySelectorAll('.extra-swatch');
    const toggle = container.querySelector('.toggle-swatch');

    const isVisible = extraSwatches[0]?.classList.contains('visible');

    extraSwatches.forEach(swatch => {
      if (isVisible) {
        swatch.classList.remove('visible');
      } else {
        swatch.classList.add('visible');
      }
    });

    toggle.innerText = isVisible ? '+ more' : '– less';
  };




const observer = new MutationObserver(() => {
 document.querySelectorAll('.blm-product-search__result').forEach(productItem => {
    if (productItem.dataset.titleListenerAttached === "true") return;
    productItem.dataset.titleListenerAttached = "true";

    const oldSwatches = productItem.querySelectorAll('.blm-product-search-swatch-container__swatch');
    const swatches = [];

    oldSwatches.forEach(swatch => {
      const newSwatch = swatch.cloneNode(true);
      swatch.replaceWith(newSwatch);
      swatches.push(newSwatch);
    });

    const titleContainer = productItem.querySelector('.variant_inline');
    const titleLink = productItem.querySelector('.blm-product-search-details-container__title');
    const addToCartBtn = productItem.querySelector('.add_to_cart_btn');
    const wishlistBtn = productItem.querySelector('.addtowishlistbtn');

    const titles = swatches.map(swatch => swatch.getAttribute('data-title'));
    const vids = swatches.map(swatch => swatch.getAttribute('data-vid'));

    swatches.forEach((swatch, index) => {
      swatch.addEventListener('click', (event) => {
        // 1. Set swatch active state
        swatches.forEach(item => item.classList.remove('active'));
        event.target.classList.add('active');

        // 2. Update images
        const imageContainers = productItem.querySelectorAll('.blm-product-search-image-container');
        imageContainers.forEach(imageContainer => {
          const images = imageContainer.querySelectorAll('.blm-product-search-swatch-image');
          images.forEach((img, i) => {
            img.style.display = (i === index) ? 'block' : 'none';
          });
        });

        // 3. Update price
        productItem.querySelectorAll('.blm-product-search-details-container__price').forEach((price, i) => {
          price.classList.toggle('active', i === index);
        });

        // 4. Update inline variant title
        if (titleContainer && titles[index]) {
          titleContainer.textContent = '-' + titles[index];
        }

        // 5. Update product title link
        if (titleLink && vids[index]) {
          const href = new URL(titleLink.href);
          href.searchParams.set('variant', vids[index]);
          titleLink.href = href.toString();
        }

        // 6. Update add to cart button
        if (addToCartBtn && vids[index]) {
          const href = new URL(addToCartBtn.href);
          href.searchParams.set('variant', vids[index]);
          addToCartBtn.href = href.toString();
        }

        // 7. Update wishlist
        if (wishlistBtn && vids[index]) {
          const url = new URL(wishlistBtn.getAttribute('data-producturl'));
          url.searchParams.set('variant', vids[index]);
          wishlistBtn.setAttribute('data-producturl', url.toString());
          wishlistBtn.setAttribute('data-varientid', vids[index]);
        }
      });
    });
  });

 // GRID TOGGLE FUNCTIONALITY
  const gridButtons = document.querySelectorAll('.custom.toolbar-icon');
  const productListing = document.querySelector('.productListing');

  if (gridButtons.length && productListing) {
    gridButtons.forEach(button => {
      button.addEventListener("click", function () {
        // Remove active class from all buttons
        gridButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        // Get desired column value
        const colValue = button.getAttribute("data-col");

        // Remove existing col-* classes
        for (const cls of Array.from(productListing.classList)) {
          if (cls.startsWith('col-')) {
            productListing.classList.remove(cls);
          }
        }

        // Add new column class
        if (colValue) {
          productListing.classList.add(`col-${colValue}`);
        }
      });
    });
  }

  

  
});

observer.observe(document.body, { childList: true, subtree: true });



// add new js


  window.addEventListener('scroll', function() {
    var scroll = document.documentElement.scrollTop;
    var targetDiv = document.querySelector('.cori_toolbar');

    if (targetDiv) {
        if (scroll >= 500) {
            targetDiv.classList.add('sticky-active');
        } else {
            targetDiv.classList.remove('sticky-active');
        }
    }
});


    
});




